#import "../fragments/ai-stat-fragment.graphql"
#import "../fragments/ai-user-fragment.graphql"
#import "../fragments/ai-feature-fragment.graphql"

query GetAiHomepage($period: AiFeaturePeriod!) {
    aiHomepage(period: $period) {
        hasAiUsage
        stats {
            ...AiStatFragment
        }
        topUsers {
            ...AiUserFragment
        }
        topFeatures {
            ...AiFeatureFragment
        }
    }
}
